import { render } from "./HeroListShowDetailInfoStore.vue?vue&type=template&id=a97a27cc&scoped=true"
import script from "./HeroListShowDetailInfoStore.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetailInfoStore.vue?vue&type=script&lang=js"

import "./HeroListShowDetailInfoStore.vue?vue&type=style&index=0&id=a97a27cc&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97a27cc"]])

export default __exports__